import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { categoriesSelector } from "../modules/products/selectors";
import SelectionTiles from "./selectionTiles";
import { ChevronDown } from "lucide-react";
import Collapse from "./collapse";

function CategoryFilter({ setFilteredCategories }) {
  const categories = useSelector(categoriesSelector);
  const [activeCategories, setActiveCategories] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const selected = categories.filter((category) =>
    activeCategories.includes(category.id)
  );
  const summary =
    selected.length === 0
      ? "Wszystkie kategorie"
      : selected.length === 1
      ? selected[0].name
      : `Wybrane kategorie (${selected.length})`;

  function addActiveCategory(categoryId) {
    setExpanded(false);
    if (activeCategories.includes(categoryId)) {
      setActiveCategories((state) => [
        ...state.filter((id) => id !== categoryId),
      ]);
    } else {
      setActiveCategories((state) => [...state, categoryId]);
    }
  }

  useEffect(() => {
    setFilteredCategories(
      activeCategories.length > 0
        ? categories.filter((c) => activeCategories.includes(c.id))
        : categories
    );
  }, [activeCategories, categories, setFilteredCategories]);

  if (categories.length === 0) return null;

  return (
    <div className="category-filter">
      <span className="category-filter__label interface-label">Kategorie</span>
      <button
        type="button"
        className="category-filter__toggle"
        aria-expanded={expanded}
        aria-controls="category-filter-options"
        onClick={() => setExpanded((value) => !value)}
      >
        <span>{summary}</span>
        <ChevronDown size={18} aria-hidden="true" />
      </button>
      <Collapse
        mobileOnly
        expanded={expanded}
        id="category-filter-options"
        className="category-filter__panel"
      >
        <div className="category-filter__options">
          <SelectionTiles
            ariaLabel="Filtruj według kategorii"
            layout="horizontal"
            multiple
            options={categories.map((category) => ({
              value: category.id,
              label: category.name,
              ariaLabel: `Kategoria ${category.name}`,
            }))}
            value={activeCategories}
            wrap
            onChange={addActiveCategory}
            renderOption={({ label }) => (
              <span className="selection-tile__label">{label}</span>
            )}
          />
        </div>
      </Collapse>
    </div>
  );
}

export default CategoryFilter;
